import { Observable } from 'rxjs'
import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { License } from '../models/license-details'
import { LicenseApptGateway } from './license-appt-gateway'
import { LicenseStatus } from '../models/license-status'
import { AppointmentStatus } from '../models/appointment-status'
import { ValidatedSelectOptionModel as State } from '../../validations/validated-dropdown.component'
import { ContentManagementDetail } from '../../content-management/models/content-mgt-detail'
import { OrgSettingsModel } from '../../org-management/models/org-settings-model'

@Injectable()
export class NetworkLicenseCheckGateway extends LicenseApptGateway {
    constructor(private http: HttpClient) {
        super()
    }

    getUserLicenseDetails(userProfileID: number): Observable<License[]> {
        return this.http.get<License[]>('../api/getUserLicenseDetails/' + userProfileID)
    }

    getUserStatesForLicense(): Observable<State[]> {
        return this.http.get<State[]>('../api/GetUserStatesForLicense/')
    }

    getUserLicenseDetailsForEnrollment(userProfileName: string): Observable<State[]> {
        return this.http.get<State[]>('../api/GetStatesForLicenseForEnrollment/' + userProfileName)
    }

    getUsersLicenseStates(userProfileName: string): Observable<State[]> {
        return this.http.get<State[]>('../api/GetStatesForLicenseForMailServiceEnrollment/' + userProfileName)
    }

    deleteLicense(licenseID: number, UserProfileID: number): Observable<License[]> {
        let delURL = '../api/deleteLicense/' + licenseID + '/' + UserProfileID

        return this.http.get<License[]>(delURL)
    }
    saveLicense(license: License): Observable<License[]> {
        return this.http.post<License[]>('../api/saveLicense', JSON.stringify(license))
    }
    editLicense(license: License): Observable<License[]> {
        return this.http.post<License[]>('../api/editLicense', JSON.stringify(license))
    }

    getAllLicenseStatus(): Observable<LicenseStatus[]> {
        let URL = '../api/GetAllLicenseStatus'
        return this.http.get<LicenseStatus[]>(URL)
    }

    getAllAppointment(): Observable<AppointmentStatus[]> {
        let URL = '../api/GetAllAppointmentStatus'
        return this.http.get<AppointmentStatus[]>(URL)
    }
    getAllStates(userProfileID: number): Observable<State[]> {
        let URL = '../api/GetStatesForLicense/' + userProfileID
        return this.http.get<State[]>(URL)
    }

    updateStatusofLicense(license: License): Observable<License[]> {
        return this.http.post<License[]>('../api/updateStatusofLicense', JSON.stringify(license))
    }

    addAppointment(license: License): Observable<License[]> {
        return this.http.post<License[]>('../api/addAppointment', JSON.stringify(license))
    }
    getExpireLicense(userProfileID: number): Observable<License[]> {
        return this.http.get<License[]>('../api/getUserExpireLicenseDetails/' + userProfileID)
    }
    getContentDetails(parentshortname: string, sectionshortname: string): Observable<ContentManagementDetail[]> {
        let getURL = '../api/content/getContentByParentAndSectionName/' + parentshortname + '/' + sectionshortname
        return this.http.get<ContentManagementDetail[]>(getURL)
    }

    getFMOSettings(orgId: string): Observable<OrgSettingsModel[]> {
        let getUrl = '../api/getFMOSettings/' + orgId + '/General Settings'
        return this.http.get<OrgSettingsModel[]>(getUrl)
    }
}
